import { abortable } from './abort';

/**
 * async sleep
 * @param ms - time to sleep in milliseconds
 * @returns promise that resolves after ms is up
 */
export const sleep = async (ms = 0, signal?: AbortSignal) => {
  signal?.throwIfAborted();
  let timeout: NodeJS.Timeout | null = null;
  return abortable(
    new Promise((resolve) => {
      timeout = setTimeout(resolve, ms);
    }),
    signal
  ).finally(() => {
    if (timeout) {
      clearTimeout(timeout);
    }
  });
};
